<template>
    <div style="background:#F4F4F4">
        <el-row>
            <el-col :span="12" :offset="10">
                <h2 class="title">{{yearMonthStr}}月度汇总</h2>
            </el-col>
            <el-col class="queryform">
                <el-form :inline="true" :model="queryform" class="demo-form-inline toolbar" style="color:#111111"
                    @submit.native.prevent>
                    <el-form-item label="老人姓名">
                        <el-input v-model="queryform.oldName" placeholder="请输入老人姓名" clearable
                            @keyup.enter.native.prevent="getOldFeeList"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="老人身份证">
                        <el-input v-model="queryform.oldIdCard" placeholder="请输入老人身份证" clearable
                            @keyup.enter.native.prevent="getOldFeeList"></el-input>
                    </el-form-item> -->
                    <el-form-item label="人员类型">
                        <el-input v-model="queryform.peopleType" placeholder="请输入老人类型" clearable
                            @keyup.enter.native.prevent="getOldFeeList"></el-input>
                    </el-form-item>
                    <el-form-item label="月份">
                        <el-date-picker v-model="queryform.dayStr" type="month" style="width: 240px"
                            value-format="yyyy-MM" placeholder="选择月份"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="margin-left:20px">
                        <el-button type="primary" style="font-size:13px" icon="el-icon-search" size="small" plain
                            @click="getOldFeeList">查询</el-button>
                        <el-button type="info" style="font-size:13px" icon="el-icon-download" size="small" plain
                            @click="exportExcel1">收入汇总表</el-button>
                        <el-button type="info" style="font-size:13px" icon="el-icon-download" size="small" plain
                            @click="exportExcel2">收支明细表</el-button>
                        <el-button type="info" style="font-size:13px" icon="el-icon-download" size="small" plain
                            @click="exportExcel3">占比表</el-button>
                        <el-button type="warning" style="font-size:13px" size="small" plain
                            @click="openGenerateDialog">生成月度缴费单</el-button>
                            <!-- 收入汇总表
                            收支明细表
                            占比表 -->
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col>
                <el-table :data="tableData"
                        :header-cell-style="{
                        'text-align': 'center',
                        'font-weight': '600',
                        color: '#2d2d2d',
                        'background-color': '#d4f5fa',
                        }"
                        :cell-style="{ 'text-align': 'center','font-size': '13px' }"
                        :row-style="tableRowStyle"
                        style="width: 100%">
                    <el-table-column prop="oldName" label="姓名" width="80px" align="center"></el-table-column>
                    <el-table-column prop="sex" label="性别" width="60px" align="center">
                        <template slot-scope="scope">
                            <p v-if="scope.row.sex == 0">男</p>
                            <p v-else>女</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="oldIdCard" label="身份证号" width="160px" align="center"></el-table-column>

                    <!-- <el-table-column prop="peopleType" label="身份类别" width="100px" align="center"></el-table-column> -->
                    <el-table-column prop="levelCareName" label="护理等级" width="100px" align="center"></el-table-column>
                    <el-table-column prop="roomNo" label="房间号" width="100px" align="center"></el-table-column>

                    <el-table-column prop="registryTime" label="入院时间"  min-width="100px" align="center"></el-table-column>
                    <el-table-column prop="bedFee" label="床位费" min-width="80px" align="center"></el-table-column>
                    <!-- <el-table-column prop="gonggongfee" label="公共服务费" min-width="80px" align="center"></el-table-column> -->
                    <el-table-column prop="hulifee" label="护理费" min-width="80px" align="center"></el-table-column>
                    <el-table-column prop="huoshifee" label="餐饮费" min-width="80px" align="center"></el-table-column>
                    <!-- <el-table-column prop="gexinfee" label="个性服务费" width="100px" align="center"></el-table-column>
                    <el-table-column prop="zhiliaofee" label="治疗费" min-width="80px" align="center"></el-table-column>
                    <el-table-column prop="dianfee" label="电费" min-width="70px" align="center"></el-table-column> -->
                    <el-table-column prop="otherFee" label="其他费用" min-width="80px" align="center"></el-table-column>
                    <el-table-column prop="totalFee" label="费用合计" min-width="80px" align="center"></el-table-column>
                    <el-table-column prop="needFee" label="应缴数" min-width="70px" align="center"></el-table-column>
                    <el-table-column label="操作" min-width="120px" align="center">
                        <template slot-scope="scope">
                            <el-button type="warning" size="mini"
                                @click="showConsumption(scope.row)">明细</el-button>
                            <el-button type="primary" size="mini"
                                @click="showMonthlyBill(scope.row)">缴费单</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination style="color:#fff;text-align: center;margin-top:15px" background
                    layout="total, prev, pager, next" :total="total" @current-change="changePage"></el-pagination>
            </el-col>

            <!-- 消费记录 -->
            <el-dialog title="消费记录" width="60%" style="margin-top:-10vh" :visible.sync="dialogConsumption"
                :close-on-click-modal="false">
                <el-table :data="consumptionRecordList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                        'text-align': 'center',
                        'font-size': '16px',
                        'font-weight': '600',
                        color: '#2d2d2d',
                        'background-color': '#d4f5fa',
                    }">
                    <el-table-column prop="oldName" label="老人姓名" align="center"></el-table-column>
                    <el-table-column prop="type" label="费用类型" :formatter="formatType" align="center"></el-table-column>
                    <el-table-column prop="projectType" label="项目类别" :formatter="formattype2"
                        align="center"></el-table-column>
                    <el-table-column prop="projectName" label="费用项目" align="center"></el-table-column>
                    <el-table-column prop="consumptionFee" label="金额" align="center"></el-table-column>
                    <el-table-column prop="createdTime" label="费用发生时间" align="center" width="180px"></el-table-column>
                </el-table>
                <el-pagination background @current-change="consumptionPageChange" :current-page="consumptionPage"
                    layout="total, prev, pager, next" :total="consumptionTotal" :page-size="pageSize" align="center"
                    class="fenye"></el-pagination>
                <div slot="footer" class="dialog-footer" align="center">
                    <el-button @click.native="dialogConsumption = false">关 闭</el-button>
                </div>
            </el-dialog>

        </el-row>

        <!-- 月度缴费单弹窗 -->
        <el-dialog :title="monthlyBillDialogTitle" width="600px" style="margin-top:-10vh"
            :visible.sync="dialogMonthlyBill" :close-on-click-modal="false">
            <div v-if="monthlyBillData">
                <el-descriptions :column="2" border size="small">
                    <el-descriptions-item label="老人姓名">{{ monthlyBillRow && monthlyBillRow.oldName }}</el-descriptions-item>
                    <el-descriptions-item label="账单月份">{{ monthlyBillData.billYearMonth }}</el-descriptions-item>
                    <el-descriptions-item label="周期费用">{{ monthlyBillData.periodFee }} 元</el-descriptions-item>
                    <el-descriptions-item label="按次费用">{{ monthlyBillData.perUseFee }} 元</el-descriptions-item>
                    <el-descriptions-item label="调整差额">{{ monthlyBillData.reviseDiff }} 元</el-descriptions-item>
                    <el-descriptions-item label="请假退费">{{ monthlyBillData.leaveRefund }} 元</el-descriptions-item>
                    <el-descriptions-item label="折扣优惠">{{ monthlyBillData.discountAmount }} 元</el-descriptions-item>
                    <el-descriptions-item label="补贴金额">{{ monthlyBillData.subsidyAmount }} 元</el-descriptions-item>
                    <el-descriptions-item label="应缴合计" :span="2">
                        <span style="font-size:16px;font-weight:bold;color:#e6a23c">{{ monthlyBillData.totalAmount }} 元</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="实际扣款">{{ monthlyBillData.actualDeduct }} 元</el-descriptions-item>
                    <el-descriptions-item label="账单状态">
                        <el-tag :type="monthlyBillData.billStatus == 1 ? 'success' : 'warning'" size="small">
                            {{ monthlyBillData.billStatus == 1 ? '已扣款' : '待扣款' }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="当前余额">{{ monthlyBillData.remainder }} 元</el-descriptions-item>
                </el-descriptions>
            </div>
            <div v-else style="text-align:center;padding:30px;color:#999">
                本月暂无月度缴费单
            </div>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click="dialogMonthlyBill = false">关 闭</el-button>
            </div>
        </el-dialog>

        <!-- 生成月度缴费单弹窗 -->        <el-dialog title="生成月度缴费单" :visible.sync="generateDialogVisible"
            width="360px" :close-on-click-modal="false">
            <el-form label-width="80px">
                <el-form-item label="账单月份">
                    <el-date-picker
                        v-model="generateYearMonth"
                        type="month"
                        placeholder="选择月份"
                        value-format="yyyy-MM"
                        style="width: 200px;">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="generateDialogVisible = false">取消</el-button>
                <el-button type="warning" :loading="generateLoading" @click="generateMonthFee">确认生成</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    
  import { baseURL } from "@/utils/request.js";
  import { formatConsumptionChargeType } from "@/utils/consumptionChargeType";
export default {
    name: "financeView",
    data() {
        return {
            serviceItemsOptions: [],
            tableData: [
            ],
            total: 0,
            pageNum: 1,
            pageSize:10,
            yearMonthStr:"",
            queryform: {
                dayStr:"",
                oldName:"",
                oldIdCard:"",
                peopleType:"",

            },
            dialogConsumption: false,
            consumptionRecordList: [],
            consumptionPage: 1,
            consumptionTotal: 0,
            quertForm: {},
            generateDialogVisible: false,
            generateYearMonth: null,
            generateLoading: false,
            dialogMonthlyBill: false,
            monthlyBillData: null,
            monthlyBillRow: null,
            monthlyBillDialogTitle: '月度缴费单',
        };
    },
    methods: {
        changePage(val) {
            this.pageNum = val;
            this.getOldFeeList();
        },
        oldCharge() {

        },
        showConsumption(row) {
            this.consumptionPage = 1;
            this.consumptionTotal = 0;
            this.dialogConsumption = true;
            this.consumptionRecordList = [];
            this.quertForm = {
                oldId: row.oldId,
                statusList: [],
            }
            this.queryConsumptionList();
        },
        consumptionPageChange(val) {
            this.consumptionPage = val;
            this.queryConsumptionList();
        },
        queryConsumptionList() {
            let param = {
                oldId: this.quertForm.oldId,
                statusList: this.quertForm.statusList,
                pageNum: this.consumptionPage,
                yearMonthStr: this.yearMonthStr,
                pageSize: this.pageSize,
            };
            this.$postJson("fmc/account/queryConsumptionRecord", param).then((res) => {
                this.consumptionRecordList = res.result.list; //列表数据
                this.consumptionTotal = Number(res.result.total); //页码total
            });
        },
        showMonthlyBill(row) {
            this.monthlyBillRow = row;
            this.monthlyBillData = null;
            const yearMonth = this.yearMonthStr || this.getNowFormatDate();
            this.monthlyBillDialogTitle = row.oldName + ' — ' + yearMonth + ' 月度缴费单';
            this.dialogMonthlyBill = true;
            this.$postJson("fmc/monthlyBill/queryWithPage", {
                oldId: row.oldId,
                billYearMonth: yearMonth,
                pageNum: 1,
                pageSize: 1,
            }).then(res => {
                const list = res.result && res.result.list;
                this.monthlyBillData = list && list.length > 0 ? list[0] : null;
            });
        },
        openGenerateDialog() {            this.generateYearMonth = this.yearMonthStr || this.getNowFormatDate();
            this.generateDialogVisible = true;
        },
        generateMonthFee() {
            if (!this.generateYearMonth) {
                this.$message.warning("请选择账单月份");
                return;
            }
            this.generateLoading = true;
            this.$postJson("fmc/account/generateMonthFee", { yearMonth: this.generateYearMonth }).then((res) => {
                this.generateLoading = false;
                if (res.code == 200) {
                    this.$message.success("生成成功");
                    this.generateDialogVisible = false;
                    this.getOldFeeList();
                } else {
                    this.$message.error(res.message || "生成失败");
                }
            }).catch(() => {
                this.generateLoading = false;
            });
        },
        formatType(row) {
            return formatConsumptionChargeType(row);
        },

        formattype2(row) {
            if (row.type == 5) {
                if (row.projectType == "1") {
                    return "现金支付";
                } else if (row.projectType == "2") {
                    return "刷卡支付";
                } else if (row.projectType == "3") {
                    return "移动支付";
                } else {
                    return row.projectType;
                }
            } else {
                return row.projectType;
            }
        },
        //修改table tr行的背景色
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 == 0) {
              return "background-color: #ffffff";
            } else {
              return "background-color: #e4f5f8";
            }
        },
        //表格颜色
        rowStyle(row) {
            if (row.rowIndex % 2 == 0) {
                return { background: "#086abb", color: "#fff" };
            } else {
                return { background: "#3c8dd4", color: "#fff" };
            }
        },
        exportExcel1(){
            window.location.href =
            baseURL +
            `fmc/export/monthlyFeeReport?groupId=${window.sessionStorage.getItem("groupId")}`+'&dayStr='+this.yearMonthStr;
        },
        exportExcel2(){
            window.location.href =
            baseURL +
            `fmc/export/accountReport?groupId=${window.sessionStorage.getItem("groupId")}`+'&dayStr='+this.yearMonthStr;
        },
        exportExcel3(){
            window.location.href =
            baseURL +
            `fmc/export/feeItemRatioReport?groupId=${window.sessionStorage.getItem("groupId")}`+'&dayStr='+this.yearMonthStr;
        },
        getOldFeeList() {
            let param = {
                oldName: this.queryform.oldName,
                oldIdCard: this.queryform.oldIdCard,
                peopleType: this.queryform.peopleType,
                dayStr: this.queryform.dayStr,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            };
            this.yearMonthStr = this.queryform.dayStr;
            this.$postJson("fmc/account/queryOldMonthFeeWithPage", param).then((res) => {
                this.tableData = res.result.list; //列表数据
                this.tableData.forEach(item=>{
                    item.needFee = item.remainder >0? 0:(0-item.remainder)
                    // let totalFee = 0;
                    // let otherFee = 0;
                    // item.needFee = item.remainder >0? 0:(0-item.remainder)
                    // item.consumptionRechargeRecordVoList.forEach(item2=>{
                    //     if(item2.type<5){
                    //         totalFee = totalFee + item2.consumptionFee;
                    //     }else if(item2.type == 6 || item2.type == 7){
                    //         //退费金额
                    //         totalFee = totalFee - item2.consumptionFee;
                    //     }
                    //     // 调整补缴;
                    //     // 请假退费;
                    //     // 出院退费;
                    //     if(item2.projectType == "床位费"){
                    //         item.bedFee = item2.consumptionFee;
                    //     }
                    //     // else if(item2.projectType == "公共服务费"){
                    //     //     item.gonggongfee = item2.consumptionFee;
                    //     // }
                    //     else if(item2.projectType == "护理费"){
                    //         item.hulifee = item2.consumptionFee;
                    //     }else if(item2.projectType == "伙食费"||item2.projectType == "餐饮费"){
                    //         item.huoshifee = item2.consumptionFee;
                    //     }else if(item2.projectType == "个性化服务费"|| item2.projectType == "特色服务"){
                    //         item.gexinfee = item2.consumptionFee;
                    //     }else if(item2.projectType == "电费"){
                    //         item.dianfee = item2.consumptionFee;
                    //     }else if(item2.projectType == "治疗费"){
                    //         item.zhiliaofee = item2.consumptionFee;
                    //     }else {
                    //         if(item2.type<5){
                    //             otherFee= otherFee + item2.consumptionFee;
                    //         }else if(item2.type == 6|| item2.type == 7){
                    //             otherFee= otherFee - item2.consumptionFee;
                    //         }
                    //     }
                    // })
                    // item.totalFee = totalFee;
                    // item.otherFee = otherFee;
                })
                this.total = Number(res.result.total); //页码total
            });
        },
        getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            var currentdate = year + seperator1 + month;
            return currentdate;
        },
    },
    mounted() {
        this.queryform.dayStr = this.getNowFormatDate();
        this.yearMonthStr = this.queryform.dayStr;
        this.getOldFeeList();
    }
};
</script>
<style scoped>
.title {
    font-size: 32px;
    margin-top: 6px;
}

.table {
    width: 100%;
    margin-top: 20px;
    border-color: #7EC0EE;
    border: 1px solid #76B8D3;
}
.queryform {
    margin-top: 10px;
}
</style>
